import { useQuery } from "react-query";

// style
import "./style.scss";
import { useTheme } from "../ListingTheme";

export const ListingHeadingReuseComp = ({ heading, comp }: any) => {
	const theme = useTheme();

	return (
		<div
			className={`listing__heading__reuse__comp ${
				theme?.name === "xseries" && "x-series-heading"
			} `}
			id={heading}
		>
			<div className="heading__top">
				<span
					className={
						theme?.name === "NEXT"
							? "next__heading"
							: `listing__normal__heading`
					}
				>
					<h2 style={{ color: theme?.primaryTextColor }}>{heading}</h2>
				</span>
			</div>
			<div className="listing__heading__content">{comp}</div>
		</div>
	);
};
